import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  MenuItem,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
  Alert as MuiAlert,
  Pagination,
  Avatar
} from '@mui/material'
import IconButton from '@mui/material/IconButton'
import AddBoxIcon from '@mui/icons-material/AddBox'
import { useEffect, useState, forwardRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import KitchenCounterDrawer from '../counters/counters/kitchenCounterDrawer'
import CounterGroupsDrawer from '../counters/counters/counterGroupsDrawer'
import MainCard, {
  SnackBarHideDuration,
  ConfirmationDialog,
  SnackBarTransition,
  ShowNoRecordsFound,
  stringAvatar,
  ErrorScreen
} from '../../utils/ui_utils'
import { businessCheck } from '../../utils/utils'
import { Add, Delete } from '@mui/icons-material'
import UserTypeShimmer from '../../utils/ui_components/shimmers/userTypeShimmer'
import {
  useCreateKitchenCounter,
  useFetchKitchenCounters,
  useUpdateKitchenCounter
} from '../../modules/kitchenCounters/kitchenCountersHooks'
import {
  useCreateCounterGroup,
  useFetchCounterGroups,
  useUpdateCounterGroup
} from '../../modules/counterGroup/counterGroupsHooks'
import { useFetchOutlet } from '../../modules/outlet/outletHooks'
import _ from 'lodash'

function KitchenCounter() {
  const [page, setPage] = useState(1)
  const [page1, setPage1] = useState(1)
  const [limit, setLimit] = useState(12)
  const [pagecount, setPageCount] = useState(1)
  const [pagecountCG, setPageCountCG] = useState(1)
  const [goToPageInput, setGoToPageInput] = useState('')
  const [goToPageInputCG, setGoToPageInputCG] = useState('')

  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)

  const [kitchenCounterDrawerMode, setKitchenCounterDrawerMode] =
    useState('edit')
  const [kitchenCounterDrawerVisiblity, setKitchenCounterDrawerVisiblity] =
    useState(false)
  const [initialValues, setInitialValues] = useState({})
  const [initialValuesCG, setInitialValuesCG] = useState({})
  const [selectedOutlet, setSelectedOutlet] = useState('')
  const [counterGroupsDrawerMode, setCounterGroupsDrawerMode] = useState('edit')
  const [counterGroupsDrawerVisiblity, setCounterGroupsDrawerVisiblity] =
    useState(false)
  const [selectedOutletName, setSelectedOutletName] = useState('')
  const [outlets, setOutlets] = useState([])
  const [deleteConfirmationVisibility, setDeleteConfirmationVisibility] =
    useState(false)
  const [deleteOperation, setDeleteOperation] = useState('')
  const {
    kitchenCountersData,
    kitchenCountersError,
    kitchenCountersFetch,
    kitchenCountersLoading
  } = useFetchKitchenCounters()
  const { kitchenCountersCreate } = useCreateKitchenCounter()
  const { kitchenCountersUpdate } = useUpdateKitchenCounter()
  const {
    fetchAllCounterGroups,
    fetchAllCounterGroupsData,
    fetchCounterGroups,
    fetchCounterGroupsData,
    fetchCounterGroupsError,
    fetchCounterGroupsLoading
  } = useFetchCounterGroups()
  const { createCounterGroup } = useCreateCounterGroup()
  const { updateCounterGroup } = useUpdateCounterGroup()
  const { outletFetch, outletFetchData, outletFetchError, outletFetchLoading } =
    useFetchOutlet()

  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }
  const handlePageChange = async (event, value) => {
    setPage(value)
    let payload = {
      outlet_id: selectedOutlet,
      pageNumber: value,
      limit: limit
    }
    kitchenCountersFetch(payload)
  }

  const handlePageChangeCG = async (event, value) => {
    setPage1(value)
    let payload = {
      outlet_id: selectedOutlet,
      pageNumber: value,
      limit: limit
    }
    fetchCounterGroups(payload)
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (/^\d+$/.test(value) || value === '') {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNum = parseInt(goToPageInput, 10)
    if (pageNum >= 1 && pageNum <= pagecount) {
      handlePageChange(null, pageNum)
      setGoToPageInput('')
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit()
    }
  }

  const handleGoToPageChangeCG = (event) => {
    const value = event.target.value
    if (/^\d+$/.test(value) || value === '') {
      setGoToPageInputCG(value)
    }
  }

  const handleGoToPageSubmitCG = () => {
    const pageNum = parseInt(goToPageInputCG, 10)
    if (pageNum >= 1 && pageNum <= pagecountCG) {
      handlePageChangeCG(null, pageNum)
      setGoToPageInputCG('')
    }
  }

  const handleGoToPageKeyPressCG = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmitCG()
    }
  }

  const pageCount = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCount(count)
  }

  const pageCountCG = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCountCG(count)
  }

  const history = useNavigate()

  useEffect(() => {
    businessCheck(history)
    let payload = {
      pageNumber: 1,
      limit: 1000
    }
    outletFetch(payload)
  }, [])

  useEffect(() => {
    if (kitchenCountersData.data?.length > 0) {
      pageCount(kitchenCountersData.total)
    }
  }, [kitchenCountersData])

  useEffect(() => {
    if (fetchCounterGroupsData.data?.length > 0) {
      pageCountCG(fetchCounterGroupsData.total)
    }
  }, [fetchCounterGroupsData])

  useEffect(() => {
    if (outletFetchData.data?.length > 0) {
      setOutlets(outletFetchData.data)
      setSelectedOutlet(outletFetchData.data[0]._id)
      setSelectedOutletName(outletFetchData.data[0].name)
      let payload = {
        outlet_id: outletFetchData.data[0]._id,
        pageNumber: page,
        limit: limit
      }
      kitchenCountersFetch(payload)
      payload.pageNumber = page1
      fetchCounterGroups(payload)
      let payload2 = {
        outlet_id: outletFetchData.data[0]._id,
        pageNumber: 1,
        limit: 100
      }
      fetchAllCounterGroups(payload2)
    } else {
      setOutlets([])
      setSelectedOutlet('')
      setSelectedOutletName('')
    }
  }, [outletFetchData])

  const handleOutletChange = (event) => {
    setSelectedOutlet(event.target.value)
    outlets.map((outlet) => {
      if (outlet._id == event.target.value) {
        setSelectedOutletName(outlet.name)
        return
      }
    })
    fetchCounterGroupsKitchenCountersOnError(event.target.value)
  }

  const fetchOutletOnError = () => {
    let payload = {
      pageNumer: 1,
      limit: 1000
    }
    outletFetch(payload)
  }

  const fetchCounterGroupsKitchenCountersOnError = (outletId) => {
    let payload = {
      outlet_id: outletId,
      pageNumber: page,
      limit: limit
    }
    kitchenCountersFetch(payload)
    payload.pageNumber = page1
    fetchCounterGroups(payload)
    payload.pageNumber = 1
    payload.limit = 100
    fetchAllCounterGroups(payload)
  }
  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  const CunterGroupsListUI = ({ counterGroup }) => (
    <MainCard
      sx={{
        mt: 1,
        p: 2,
        alignItems: 'center',
        transition: 'box-shadow 0.3s ease',
        borderRadius: 1,
        '&:hover': {
          boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
          backgroundColor: 'rgba(0, 0, 0, 0.04)'
        }
      }}
    >
      <Grid container column={6} spacing={1}>
        <Grid item xs md>
          <Grid
            container
            column={6}
            sx={{ alignItems: 'center', cursor: 'pointer' }}
            onClick={() => {
              setInitialValuesCG(counterGroup)
              setCounterGroupsDrawerMode('edit')
              setCounterGroupsDrawerVisiblity(true)
            }}
          >
            <Grid item>
              <Avatar {...stringAvatar(counterGroup?.name)} />
            </Grid>
            <Grid item xs md sx={{ pl: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                {counterGroup.name}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item textAlign="right">
          <IconButton
            size="small"
            color="lightRed"
            component="span"
            onClick={() => {
              let values = counterGroup
              setDeleteOperation('countergroup')
              setInitialValuesCG(values)
              setDeleteConfirmationVisibility(true)
            }}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Grid>
      </Grid>
    </MainCard>
  )

  const KitchenCounterListUI = ({ kitchenCounter, index }) => (
    <MainCard
      id={index}
      sx={{
        mt: 1,
        p: 2,
        alignItems: 'center',
        transition: 'box-shadow 0.3s ease',
        borderRadius: 1,
        '&:hover': {
          boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
          backgroundColor: 'rgba(0, 0, 0, 0.04)'
        }
      }}
    >
      <Grid container column={6} spacing={1}>
        <Grid item>
          <Avatar {...stringAvatar(kitchenCounter?.name)} />
        </Grid>
        <Grid item xs md>
          <Grid
            container
            direction={'column'}
            sx={{ pl: 1, cursor: 'pointer' }}
            onClick={() => {
              let values = _.cloneDeep(kitchenCounter)
              values.counter_group_id = kitchenCounter.counter_group?._id
              setInitialValues(values)
              setKitchenCounterDrawerVisiblity(true)
              setKitchenCounterDrawerMode('edit')
            }}
          >
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              {kitchenCounter?.name}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              {kitchenCounter?.counter_group?.name}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              Printer #: {kitchenCounter?.printer_number}
            </Typography>
          </Grid>
        </Grid>
        <Grid item textAlign="right">
          <IconButton
            size="small"
            color="lightRed"
            component="span"
            onClick={() => {
              let values = _.cloneDeep(kitchenCounter)
              values.counter_group_id = kitchenCounter.counter_group?._id
              setDeleteOperation('kitchencounter')
              setInitialValues(values)
              setDeleteConfirmationVisibility(true)
            }}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Grid>
      </Grid>
    </MainCard>
  )

  return (
    <>
      <Helmet title="Counters" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item>
          <Typography variant="h4" gutterBottom display="inline">
            Kitchen Counters and Counter Groups
          </Typography>
        </Grid>
        {fetchCounterGroupsData.data &&
          fetchCounterGroupsData.data.length <= 0 && (
            <Grid item>
              <Button
                startIcon={<Add />}
                variant="contained"
                size="small"
                color="primary"
                onClick={() => {
                  if (
                    selectedOutlet != null &&
                    selectedOutlet != undefined &&
                    selectedOutlet != ''
                  ) {
                    setCounterGroupsDrawerVisiblity(true)
                    setInitialValuesCG({
                      name: '',
                      outlet_id: ''
                    })
                    setCounterGroupsDrawerMode('new')
                  } else {
                    toastMessage('Select Outlet', 'warning')
                  }
                }}
              >
                Add Counter Group
              </Button>
            </Grid>
          )}
      </Grid>
      <Divider style={{ paddingTop: 10 }} />
      {outletFetchError ? (
        <ErrorScreen
          onClick={() => {
            fetchOutletOnError()
          }}
        />
      ) : (
        <div>
          {
            <Grid container spacing={6} style={{ paddingTop: 10 }}>
              <Grid item md={3}>
                <TextField
                  size="small"
                  label="Outlet"
                  id="outlet_id"
                  name="outlet_id"
                  variant="outlined"
                  margin="dense"
                  value={selectedOutlet}
                  onChange={handleOutletChange}
                  select
                  fullWidth
                >
                  {outlets.map((outlet) => (
                    <MenuItem key={outlet._id} value={outlet._id}>
                      {outlet.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          }
          {fetchCounterGroupsError || kitchenCountersError ? (
            <ErrorScreen
              onClick={() => {
                fetchCounterGroupsKitchenCountersOnError(selectedOutlet)
              }}
            />
          ) : (
            <div>
              {(fetchCounterGroupsLoading || kitchenCountersLoading) && (
                <Grid container spacing={5} sx={{ paddingTop: 10 }}>
                  <UserTypeShimmer />
                  <Grid
                    container
                    direction="column"
                    my={10}
                    sx={{ paddingTop: 25 }}
                  >
                    <UserTypeShimmer />
                  </Grid>
                </Grid>
              )}
              {!fetchCounterGroupsLoading &&
                !kitchenCountersLoading &&
                fetchCounterGroupsData.data &&
                fetchCounterGroupsData.data.length <= 0 && (
                  <ShowNoRecordsFound />
                )}

              {!fetchCounterGroupsLoading &&
                !fetchCounterGroupsError &&
                !kitchenCountersLoading &&
                fetchCounterGroupsData.data &&
                fetchCounterGroupsData.data.length > 0 && (
                  <Grid container spacing={5} sx={{ paddingTop: 5 }}>
                    <Grid container direction="column" mx={10} my={10}>
                      <Grid container direction="column">
                        <Grid
                          container
                          spacing={6}
                          sx={{ alignItems: 'center' }}
                        >
                          <Grid item>
                            <Typography
                              variant="h5"
                              gutterBottom
                              display="inline"
                            >
                              Counter Groups
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Tooltip
                              title="Add Counter Group"
                              placement="bottom"
                            >
                              <IconButton
                                variant="contained"
                                size="small"
                                color="primary"
                                onClick={() => {
                                  setCounterGroupsDrawerVisiblity(true)
                                  setInitialValuesCG({
                                    name: '',
                                    outlet_id: ''
                                  })
                                  setCounterGroupsDrawerMode('new')
                                }}
                              >
                                <AddBoxIcon />
                              </IconButton>
                            </Tooltip>
                          </Grid>
                        </Grid>
                        <Grid container>
                          <Grid item xs sm md>
                            <Box sx={{ margin: 2 }}>
                              <Card raised sx={{ borderRadius: 3 }}>
                                <CardContent>
                                  <Grid
                                    container
                                    columns={6}
                                    rowSpacing={3}
                                    columnSpacing={3}
                                  >
                                    {fetchCounterGroupsData.data.map(
                                      (row, i) => (
                                        <Grid item xs={6} sm={3} md={2} key={i}>
                                          <CunterGroupsListUI
                                            counterGroup={row}
                                          />
                                        </Grid>
                                      )
                                    )}
                                  </Grid>
                                </CardContent>
                                {pagecountCG > 1 && (
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 2,
                                      p: 2,
                                      backgroundColor: 'grey.50',
                                      borderRadius: 1
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        width: '100%'
                                      }}
                                    >
                                      <Pagination
                                        page={page1}
                                        color="primary"
                                        size="small"
                                        count={pagecountCG}
                                        showFirstButton
                                        showLastButton
                                        onChange={handlePageChangeCG}
                                        sx={{
                                          '& .MuiPaginationItem-root': {
                                            transition: 'all 0.2s ease-in-out'
                                          }
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 1.5,
                                        backgroundColor: 'white',
                                        p: 2,
                                        borderRadius: 1,
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                        transition:
                                          'box-shadow 0.2s ease-in-out',
                                        '&:hover': {
                                          boxShadow:
                                            '0 2px 6px rgba(0,0,0,0.12)'
                                        }
                                      }}
                                    >
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: 'text.secondary',
                                          fontWeight: 500
                                        }}
                                      >
                                        Jump to
                                      </Typography>
                                      <TextField
                                        size="small"
                                        value={goToPageInputCG}
                                        onChange={handleGoToPageChangeCG}
                                        onKeyPress={handleGoToPageKeyPressCG}
                                        placeholder="Page"
                                        sx={{
                                          width: '80px',
                                          '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white',
                                            transition: 'all 0.2s ease-in-out',
                                            '& fieldset': {
                                              borderColor: 'grey.300',
                                              borderWidth: '1px'
                                            },
                                            '&:hover fieldset': {
                                              borderColor: 'primary.main',
                                              borderWidth: '1.5px'
                                            },
                                            '&.Mui-focused fieldset': {
                                              borderColor: 'primary.main',
                                              borderWidth: '2px',
                                              boxShadow:
                                                '0 0 0 3px rgba(33, 150, 243, 0.1)'
                                            }
                                          },
                                          '& .MuiOutlinedInput-input': {
                                            textAlign: 'center',
                                            fontWeight: 500,
                                            padding: '7px 8px',
                                            height: '20px',
                                            lineHeight: '20px'
                                          }
                                        }}
                                      />
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: 'text.secondary',
                                          fontWeight: 400
                                        }}
                                      >
                                        of {pagecountCG}
                                      </Typography>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        onClick={handleGoToPageSubmitCG}
                                        disabled={
                                          !goToPageInputCG ||
                                          parseInt(goToPageInputCG, 10) < 1 ||
                                          parseInt(goToPageInputCG, 10) >
                                            pagecountCG
                                        }
                                        sx={{
                                          textTransform: 'none',
                                          fontWeight: 500,
                                          px: 2,
                                          py: 0.75,
                                          height: '34px',
                                          lineHeight: 1,
                                          transition: 'all 0.2s ease-in-out',
                                          '&:hover': {
                                            transform: 'translateY(-1px)',
                                            boxShadow:
                                              '0 4px 8px rgba(33, 150, 243, 0.3)'
                                          },
                                          '&:active': {
                                            transform: 'translateY(0)'
                                          }
                                        }}
                                      >
                                        Go
                                      </Button>
                                    </Box>
                                  </Box>
                                )}
                              </Card>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid container direction="column" my={10}>
                        <Grid
                          container
                          spacing={6}
                          sx={{ alignItems: 'center' }}
                        >
                          <Grid item>
                            <Typography
                              variant="h5"
                              gutterBottom
                              display="inline"
                            >
                              Kitchen Counters
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Tooltip
                              title="Add Kitchen Counter"
                              placement="bottom"
                            >
                              <IconButton
                                variant="contained"
                                size="small"
                                color="primary"
                                onClick={() => {
                                  setKitchenCounterDrawerMode('new')
                                  setKitchenCounterDrawerVisiblity(true)
                                  setInitialValues({
                                    name: '',
                                    counter_group_id: '',
                                    printer_number: 0
                                  })
                                }}
                              >
                                <AddBoxIcon />
                              </IconButton>
                            </Tooltip>
                          </Grid>
                        </Grid>
                        <Grid container>
                          <Grid item xs sm md>
                            <Box sx={{ margin: 2 }}>
                              <Card raised sx={{ borderRadius: 3 }}>
                                <CardContent>
                                  <Grid
                                    container
                                    columns={6}
                                    rowSpacing={3}
                                    columnSpacing={3}
                                  >
                                    {kitchenCountersData.data?.map((row, i) => (
                                      <Grid item xs={6} sm={3} md={2} key={i}>
                                        <KitchenCounterListUI
                                          kitchenCounter={row}
                                          index={i}
                                        />
                                      </Grid>
                                    ))}
                                  </Grid>
                                </CardContent>
                                {pagecount > 1 && (
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 2,
                                      p: 2,
                                      backgroundColor: 'grey.50',
                                      borderRadius: 1
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        width: '100%'
                                      }}
                                    >
                                      <Pagination
                                        page={page}
                                        color="primary"
                                        size="small"
                                        count={pagecount}
                                        showFirstButton
                                        showLastButton
                                        onChange={handlePageChange}
                                        sx={{
                                          '& .MuiPaginationItem-root': {
                                            transition: 'all 0.2s ease-in-out'
                                          }
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 1.5,
                                        backgroundColor: 'white',
                                        p: 2,
                                        borderRadius: 1,
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                        transition:
                                          'box-shadow 0.2s ease-in-out',
                                        '&:hover': {
                                          boxShadow:
                                            '0 2px 6px rgba(0,0,0,0.12)'
                                        }
                                      }}
                                    >
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: 'text.secondary',
                                          fontWeight: 500
                                        }}
                                      >
                                        Jump to
                                      </Typography>
                                      <TextField
                                        size="small"
                                        value={goToPageInput}
                                        onChange={handleGoToPageChange}
                                        onKeyPress={handleGoToPageKeyPress}
                                        placeholder="Page"
                                        sx={{
                                          width: '80px',
                                          '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white',
                                            transition: 'all 0.2s ease-in-out',
                                            '& fieldset': {
                                              borderColor: 'grey.300',
                                              borderWidth: '1px'
                                            },
                                            '&:hover fieldset': {
                                              borderColor: 'primary.main',
                                              borderWidth: '1.5px'
                                            },
                                            '&.Mui-focused fieldset': {
                                              borderColor: 'primary.main',
                                              borderWidth: '2px',
                                              boxShadow:
                                                '0 0 0 3px rgba(33, 150, 243, 0.1)'
                                            }
                                          },
                                          '& .MuiOutlinedInput-input': {
                                            textAlign: 'center',
                                            fontWeight: 500,
                                            padding: '7px 8px',
                                            height: '20px',
                                            lineHeight: '20px'
                                          }
                                        }}
                                      />
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: 'text.secondary',
                                          fontWeight: 400
                                        }}
                                      >
                                        of {pagecount}
                                      </Typography>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        onClick={handleGoToPageSubmit}
                                        disabled={
                                          !goToPageInput ||
                                          parseInt(goToPageInput, 10) < 1 ||
                                          parseInt(goToPageInput, 10) >
                                            pagecount
                                        }
                                        sx={{
                                          textTransform: 'none',
                                          fontWeight: 500,
                                          px: 2,
                                          py: 0.75,
                                          height: '34px',
                                          lineHeight: 1,
                                          transition: 'all 0.2s ease-in-out',
                                          '&:hover': {
                                            transform: 'translateY(-1px)',
                                            boxShadow:
                                              '0 4px 8px rgba(33, 150, 243, 0.3)'
                                          },
                                          '&:active': {
                                            transform: 'translateY(0)'
                                          }
                                        }}
                                      >
                                        Go
                                      </Button>
                                    </Box>
                                  </Box>
                                )}
                              </Card>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}

              <KitchenCounterDrawer
                title={
                  kitchenCounterDrawerMode == 'new'
                    ? 'Create Kitchen Counter'
                    : 'Edit Kitchen Counter'
                }
                visible={kitchenCounterDrawerVisiblity}
                okText={kitchenCounterDrawerMode == 'new' ? 'Create' : 'Update'}
                initialValues={initialValues}
                counterGroupData={fetchAllCounterGroupsData.data}
                outlet={selectedOutletName}
                onClose={() => {
                  setKitchenCounterDrawerVisiblity(false)
                }}
                onSubmit={(value) => {
                  let values = _.cloneDeep(value)
                  values.name = values.name.trim()
                  values.printer_number = +values.printer_number
                  if (kitchenCounterDrawerMode == 'new') {
                    values.outlet_id = selectedOutlet
                    kitchenCountersCreate(values, (sucess, error, message) => {
                      if (error) {
                        setKitchenCounterDrawerVisiblity(true)
                        toastMessage(error, 'error')
                      } else {
                        setKitchenCounterDrawerVisiblity(false)
                        toastMessage(message, 'success')
                        if (
                          selectedOutlet != null &&
                          selectedOutlet != undefined &&
                          selectedOutlet != ''
                        ) {
                          let payload = {
                            outlet_id: selectedOutlet,
                            pageNumber: page,
                            limit: limit
                          }
                          kitchenCountersFetch(payload)
                        }
                      }
                    })
                  } else {
                    if (values?.counter_group_id) {
                      delete values.counter_group
                    } else {
                      values.counter_group_id = values?.counter_group?._id
                      delete values.counter_group
                    }
                    values.id = values._id
                    delete values._id
                    delete values.key
                    delete values.business_id
                    kitchenCountersUpdate(values, (sucess, error, message) => {
                      if (error) {
                        setKitchenCounterDrawerVisiblity(true)
                        toastMessage(error, 'error')
                      } else {
                        setKitchenCounterDrawerVisiblity(false)
                        toastMessage(message, 'success')
                        if (
                          selectedOutlet != null &&
                          selectedOutlet != undefined &&
                          selectedOutlet != ''
                        ) {
                          let payload = {
                            outlet_id: selectedOutlet,
                            pageNumber: page,
                            limit: limit
                          }
                          kitchenCountersFetch(payload)
                        }
                      }
                    })
                  }
                }}
              />
              <CounterGroupsDrawer
                action={counterGroupsDrawerMode}
                title={
                  counterGroupsDrawerMode == 'new'
                    ? 'Create Counter Group'
                    : 'Edit Counter Group'
                }
                visible={counterGroupsDrawerVisiblity}
                initialValues={initialValuesCG}
                outlet={selectedOutletName}
                okText={counterGroupsDrawerMode == 'new' ? 'Create' : 'Update'}
                onClose={() => setCounterGroupsDrawerVisiblity(false)}
                onSubmit={(value) => {
                  let values = _.cloneDeep(value)
                  values.name = values.name.trim()
                  if (counterGroupsDrawerMode == 'new') {
                    values.outlet_id = selectedOutlet
                    createCounterGroup(
                      values,
                      async (success, error, message) => {
                        if (error) {
                          setCounterGroupsDrawerVisiblity(true)
                          toastMessage(error, 'error')
                        } else {
                          setCounterGroupsDrawerVisiblity(false)
                          toastMessage(message, 'success')
                          if (
                            selectedOutlet != null &&
                            selectedOutlet != undefined &&
                            selectedOutlet != ''
                          ) {
                            let payload = {
                              outlet_id: selectedOutlet,
                              pageNumber: page,
                              limit: limit
                            }
                            await fetchCounterGroups(payload)
                            payload.pageNumber = 1
                            payload.limit = 100
                            fetchAllCounterGroups(payload)
                          }
                        }
                      }
                    )
                  } else {
                    delete values.business_id
                    values.id = values._id
                    delete values._id
                    delete values.key
                    updateCounterGroup(
                      values,
                      async (success, error, message) => {
                        if (error) {
                          setCounterGroupsDrawerVisiblity(true)
                          toastMessage(error, 'error')
                        } else {
                          setCounterGroupsDrawerVisiblity(false)
                          toastMessage(message, 'success')
                          if (
                            selectedOutlet != null &&
                            selectedOutlet != undefined &&
                            selectedOutlet != ''
                          ) {
                            let payload = {
                              outlet_id: selectedOutlet,
                              pageNumber: page,
                              limit: limit
                            }
                            await kitchenCountersFetch(payload)
                            payload.pageNumber = page1
                            await fetchCounterGroups(payload)
                            payload.pageNumber = 1
                            payload.limit = 100
                            fetchAllCounterGroups(payload)
                          }
                        }
                      }
                    )
                  }
                }}
              />
            </div>
          )}
        </div>
      )}
      <ConfirmationDialog
        visibility={deleteConfirmationVisibility}
        title={
          deleteOperation == 'kitchencounter'
            ? 'Delete Kitchen Counter'
            : 'Delete Counter Group'
        }
        message={
          deleteOperation == 'kitchencounter'
            ? `Do you want to delete Kitchen Counter - ${initialValues.name} ?`
            : `Do you want to delete Counter Group - ${initialValuesCG.name} ?`
        }
        okText="Delete"
        cancelText={'Cancel'}
        onCancel={() => {
          setDeleteConfirmationVisibility(false)
        }}
        onOk={() => {
          if (deleteOperation == 'kitchencounter') {
            let value = _.cloneDeep(initialValues)
            value.id = value._id
            delete value?._id
            delete value?.business_id
            delete value?.counter_group
            value.delete_status = true
            delete value?.key
            kitchenCountersUpdate(value, (success, error, message) => {
              if (error) {
                toastMessage(message, 'error')
              } else {
                toastMessage('Kitchen Counter deleted', 'success')
                if (kitchenCountersData.length - 1 <= 0) {
                  setPage(1)
                  let payload = {
                    outlet_id: selectedOutlet,
                    pageNumber: 1,
                    limit: limit
                  }
                  kitchenCountersFetch(payload)
                } else {
                  let payload = {
                    outlet_id: selectedOutlet,
                    pageNumber: page,
                    limit: limit
                  }
                  kitchenCountersFetch(payload)
                }
                setDeleteConfirmationVisibility(false)
              }
            })
          } else if (deleteOperation == 'countergroup') {
            let values = _.cloneDeep(initialValuesCG)
            values.id = values._id
            delete values._id
            delete values.business_id
            values.delete_status = true
            delete values?.key
            updateCounterGroup(values, (success, error, message) => {
              if (error) {
                toastMessage(message, 'error')
              } else {
                toastMessage('Counter Group deleted', 'success')
                if (fetchCounterGroupsData.data.length - 1 <= 0) {
                  setPage1(1)
                  let payload = {
                    outlet_id: selectedOutlet,
                    pageNumber: 1,
                    limit: limit
                  }
                  fetchCounterGroups(payload)
                } else {
                  let payload = {
                    outlet_id: selectedOutlet,
                    pageNumber: page1,
                    limit: limit
                  }
                  fetchCounterGroups(payload)
                }
                setDeleteConfirmationVisibility(false)
              }
            })
          }
        }}
      />
      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  )
}

export default KitchenCounter
